import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {ReceivablesPaymentImportRow} from "../../../../shared/interface/receivables-payment-import-row";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {AuthService} from "../../../../shared/services/auth.service";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Router} from "@angular/router";
import {takeUntil} from "rxjs/operators";
import {ReceivablesPaymentImportRowService} from "../../../../shared/services/receivables-payment-import-row.service";
import {
  RECEIVABLES_PAYMENT_STATUS_OUTGOING_PAYMENT,
  RECEIVABLES_PAYMENT_STATUS_SETTLED,
  RECEIVABLES_PAYMENT_STATUS_UNSETTLED
} from "../../../../shared/services/dict.service";
import {ChangeStatementDialogComponent} from "../change-statement-dialog/change-statement-dialog.component";
import {
  ConfirmDialogWithReasonComponent
} from "../../../../shared/components/confirm-dialog-with-reason/confirm-dialog-with-reason.component";

@Component({
  selector: 'app-receivables-payment-import-row-details-view',
  templateUrl: './receivables-payment-import-row-details-view.component.html',
  styleUrls: ['./receivables-payment-import-row-details-view.component.scss']
})
export class ReceivablesPaymentImportRowDetailsViewComponent implements  OnInit, OnDestroy {
  @Input() receivablesPaymentImportsRow: Observable<ReceivablesPaymentImportRow>;
  @Output() modifyClicked = new EventEmitter<any>();
  @Output() receivablesPaymentImportsRowChanged: EventEmitter<boolean> = new EventEmitter<boolean>();


  userPermissions: ReplaySubject<UserPermissions>;
  receivablesPaymentImportsRowObject?: ReceivablesPaymentImportRow;

  readonly RECEIVABLES_PAYMENT_STATUS_UNSETTLED = RECEIVABLES_PAYMENT_STATUS_UNSETTLED;
  readonly RECEIVABLES_PAYMENT_STATUS_SETTLED = RECEIVABLES_PAYMENT_STATUS_SETTLED;
  readonly  RECEIVABLES_PAYMENT_STATUS_OUTGOING_PAYMENT = RECEIVABLES_PAYMENT_STATUS_OUTGOING_PAYMENT;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private auth: AuthService,
    private dialog: MatDialog,
    private receivablesPaymentImportRowService: ReceivablesPaymentImportRowService,
    private snack: MatSnackBar,
    private router: Router,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.receivablesPaymentImportsRow
      .pipe(takeUntil(this.destroyed$))
      .subscribe((receivablesPaymentImportRow: ReceivablesPaymentImportRow) => {
        this.receivablesPaymentImportsRowObject = receivablesPaymentImportRow;
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }


  addBalance(): void {
    const dialogRef = this.dialog.open(ChangeStatementDialogComponent, {
      width: '700px',
      data: {receivablesPaymentImportsRowObject: this.receivablesPaymentImportsRowObject},
    });

    dialogRef.afterClosed().subscribe(() => {
      this.receivablesPaymentImportsRowChanged.emit();
    });
  }

  modify(): void {
    this.modifyClicked.emit();
  }

  cancel(): void {
    const dialogRef = this.dialog.open(ConfirmDialogWithReasonComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć wpłatę?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.receivablesPaymentImportRowService.cancel( this.receivablesPaymentImportsRowObject.uuid,  result.reason)
          .subscribe(() => {
            this.snack.open('Pomyślnie usunięto wpłatę', '', {duration: 2000});
            this.receivablesPaymentImportsRowChanged.emit();
          });
      }
    });
  }
}
